export const dealSPQueryKey = 'sp'
